<template>
  <div>
    <input type="text" @focus="openDatePicker" />
    <div v-if="open" v-click-outside="closeDatePicker">
      <div class="year-picker-header">
        {{ currentYearRange }}
      </div>
      <div class="year-picker-body">
        <BaseButton
          type="link"
          :key="index"
          v-for="(year, index) in years"
          @click="handleYearClick(year)"
        >
          {{ year }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
export default {
  data() {
    return {
      years: [],
      open: false
    };
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    this.currentYearRange = `${currentYear - 1}-${currentYear + 10}`;
    if (this.value) {
      const currentYear = new Date(this.value).getFullYear();
      this.currentYearRange = `${currentYear - 1}-${currentYear + 10}`;
    }
    for (let i = currentYear - 1; i < currentYear + 11; i++) {
      this.years.push(i);
    }
  },
  directives: {
    ClickOutside
  },
  methods: {
    openDatePicker() {
      this.open = true;
    },
    closeDatePicker() {
      this.open = false;
    },
    handleYearClick(year) {
      this.$emit("change", year);
      this.closeDatePicker();
    }
  }
};
</script>

<style lang="sass">
.year-picker-header
  text-align: center
.year-picker-body
  display: grid
  grid-template-columns: auto auto auto
</style>
